import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// PD-P1 — Product Details instant-shell skeleton.
//
// Eager (NOT lazy) on purpose: it is used as the route-level Suspense fallback
// for /offer-details/:id in App.js, so it must already be in the initial bundle
// to render WHILE the Product Details route chunk is still downloading. Before
// this, that phase showed App.js's blank `<div></div>` fallback.
//
// It is a static, display-only placeholder. It deliberately mirrors the real PD
// layout using the SAME existing classes (product_single / product-detail-first
// (68%) / product-detail-second (32%) / product_show / carousel-indicators /
// carousel-inner galleryy / product_details_main / price_btns) so:
//   1. existing CSS sizes and stacks it correctly (desktop columns, mobile
//      stacked) with no new CSS, and
//   2. it visually matches the skeletons that gallery.jsx / offerDetails.jsx
//      already render during the getOfferDetail API-loading phase — so the
//      hand-off chunk-load -> API-load -> real content is shift-free.
//
// No data, no API, no react-query, no firestore, no business logic. Plain
// <div>s are used in place of <Link> so this component needs no router context.
// The real sold / auction / payment / availability state is always rendered by
// the actual components from the authoritative getOfferDetail result; this shell
// never decides or masks any of that.
export default function PdSkeleton() {
  return (
    <div aria-hidden="true">
      {/* Header placeholder bar — keeps the brand-red underline signature so the
          top does not jump when the real (lazy) Header mounts. Inline styles are
          display-only and self-contained. */}
      <div
        style={{
          background: "#fff",
          borderBottom: "4px solid #FF3F55",
          padding: "10px 0",
          textAlign: "center",
        }}
      >
        <Skeleton circle width={56} height={56} />
      </div>

      <section className="product_single pt-md-5 pb-4 bg-light">
        <div className="container-fluid">
          <div className="row mx-0 bg-white px-xl-2 py-xl-4 p-lg-4 py-md-4 px-1 py-4 position-relative align-items-start shadow">
            {/* Gallery column (68%) — mirrors gallery.jsx loading branch */}
            <div className="product-detail-first mb-lg-0 mb-md-4 mb-4">
              <div className="product_show">
                <div className="carousel">
                  <div className="carousel-indicators ">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                      <React.Fragment key={n}>
                        <div>
                          <button
                            type="button"
                            className="position-relative "
                            id="bg-white"
                          >
                            <Skeleton />
                          </button>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="carousel-inner galleryy ">
                    <Skeleton />
                  </div>
                </div>
              </div>
            </div>

            {/* Details column (32%) — mirrors offerDetails.jsx loading branch */}
            <div className="product-detail-second ">
              <div className="product_details_main">
                <div className="row">
                  <div className="col product_top mb-xl-4 mb-lg-3 mb-md-3 mb-3 d-flex pe-0">
                    <div className="hand_btnn ps-0 me-0">
                      <Skeleton width={120} />
                    </div>
                    <div className="hand_btnn ">
                      <Skeleton width={120} />
                    </div>
                  </div>

                  <div className="col-12 product_heading mb-xl-4 mb-lg-3 mb-md-3 mb-3">
                    <h2>
                      <Skeleton />
                    </h2>
                    <h2>
                      <Skeleton />
                    </h2>
                  </div>

                  <div className="col-12 mb-xl-4 mb-lg-3 mb-md-4 mb-3">
                    <Skeleton height={60} />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-12">
                    <Skeleton height={80} />
                  </div>
                </div>

                <div className="row price_btns">
                  <div className="col-6">
                    <Skeleton height={45} />
                  </div>
                  <div className="col-6">
                    <Skeleton height={45} />
                  </div>
                  <div className="col-12 mt-4">
                    <Skeleton height={45} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
